import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { createApiClient, type ApiClient } from './index';

// Lets shared components access fetchApi without prop drilling.

const ApiContext = createContext<ApiClient | null>(null);

export function ApiProvider({ tokenKey, children }: { tokenKey: string; children: ReactNode }) {
  const client = useMemo(() => createApiClient(tokenKey), [tokenKey]);
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}

export function useApi(): ApiClient {
  const client = useContext(ApiContext);
  if (!client) throw new Error('useApi must be used within ApiProvider');
  return client;
}
